module.exports = __webpack_public_path__ + "static/img/weis-qr.bb35007.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weis-qr.png
// module id = dRmz
// module chunks = 1